module.exports = __webpack_public_path__ + "img/SM.bb5768f2.svg";